module.exports = __webpack_public_path__ + "static/img/manual_zh_10.b1c3fcd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_10.png
// module id = 9vXQ
// module chunks = 4